import React from 'react'
import * as fnc from 'helpers/fnc'
import { IconButton } from './IconButton'
import { DocLinkButton } from './DocLinkButton'

interface TooltipLabelProps {
    className?: string,
    children: React.ReactNode,
    tooltip: string,
    docLink?: string,
    htmlFor?: string,
    additionalButtons?: JSX.Element[]
}

export function TooltipLabel(
    {
        children,
        tooltip,
        docLink,
        htmlFor,
        className,
        additionalButtons,
    }: TooltipLabelProps,
) {
    // Get the tooltip from documentation service if available
    return (
        <div className={`tooltip-label ${className || ''}`}>
            {children && <label htmlFor={htmlFor}>{children}</label>}
            {tooltip && <IconButton icon="fas fa-info-circle" noBg tooltip={tooltip} />}
            {docLink && <DocLinkButton noBg docLink={docLink} />}
            {additionalButtons && additionalButtons.map((button) => button)}
        </div>
    )
}

export default TooltipLabel